var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        "cancel-variant": "outline-secondary",
        centered: "",
        "ok-title": "추가",
        "cancel-title": "닫기",
        size: "lg",
        title: "관련 질환 항목 설정",
        "no-close-on-esc": "",
        "no-close-on-backdrop": "",
      },
      on: {
        ok: function ($event) {
          $event.preventDefault()
          return _vm.add()
        },
        close: function ($event) {
          $event.preventDefault()
          return _vm.close()
        },
        cancel: function ($event) {
          $event.preventDefault()
          return _vm.close()
        },
      },
      model: {
        value: _vm.showDeskDiseaseManage,
        callback: function ($$v) {
          _vm.showDeskDiseaseManage = $$v
        },
        expression: "showDeskDiseaseManage",
      },
    },
    [
      _c(
        "b-row",
        { staticClass: "mt-1" },
        [
          _c("b-table", {
            ref: "refDiseaseTable",
            staticClass: "position-relative",
            attrs: {
              "primary-key": "id",
              items: _vm.fetchDisease,
              fields: _vm.tableColumns,
              "sort-by": _vm.sortBy,
              "sort-desc": _vm.isSortDesc,
              responsive: "",
              "sticky-header": "",
            },
            on: {
              "update:sortBy": function ($event) {
                _vm.sortBy = $event
              },
              "update:sort-by": function ($event) {
                _vm.sortBy = $event
              },
              "update:sortDesc": function ($event) {
                _vm.isSortDesc = $event
              },
              "update:sort-desc": function ($event) {
                _vm.isSortDesc = $event
              },
            },
            scopedSlots: _vm._u([
              {
                key: "cell(edit)",
                fn: function (data) {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "badge badge-light-primary",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.edit(data.item)
                          },
                        },
                      },
                      [_vm._v(" 수정 ")]
                    ),
                  ]
                },
              },
              {
                key: "cell(remove)",
                fn: function (data) {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "badge badge-light-danger",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.remove(data.item)
                          },
                        },
                      },
                      [_vm._v(" 삭제 ")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("desk-disease-edit", {
        attrs: {
          "is-new": _vm.deskDiseaseIsNew,
          "edit-item": _vm.deskDiseaseItem,
          "show-desk-disease-edit": _vm.showDeskDiseaseEdit,
        },
        on: { close: _vm.deskDiseaseEdit.close },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }